import { render, staticRenderFns } from "./PillRefining.vue?vue&type=template&id=9166ae52&scoped=true"
import script from "./PillRefining.vue?vue&type=script&lang=js"
export * from "./PillRefining.vue?vue&type=script&lang=js"
import style0 from "./PillRefining.vue?vue&type=style&index=0&id=9166ae52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9166ae52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cmdgame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9166ae52')) {
      api.createRecord('9166ae52', component.options)
    } else {
      api.reload('9166ae52', component.options)
    }
    module.hot.accept("./PillRefining.vue?vue&type=template&id=9166ae52&scoped=true", function () {
      api.rerender('9166ae52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/refining/PillRefining.vue"
export default component.exports